import React from 'react';
import { EmailBlock, LayoutBlockContent } from '../../types';

interface LayoutPropertiesProps {
  block: EmailBlock;
  onUpdate: (updates: Partial<LayoutBlockContent>) => void;
  mergeTags?: Array<{ name: string; value: string; sample: string }>;
  isDarkMode: boolean;
}

export const LayoutProperties: React.FC<LayoutPropertiesProps> = ({
  block,
  onUpdate,
  isDarkMode
}) => {
  const content = block.content as LayoutBlockContent;

  return (
    <div className="space-y-4">
      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Background Color
        </label>
        <input
          type="color"
          value={content.backgroundColor || '#ffffff'}
          onChange={(e) => onUpdate({ backgroundColor: e.target.value })}
          className="w-full h-10 border rounded-md"
        />
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Padding
        </label>
        <input
          type="text"
          value={content.padding || '0'}
          onChange={(e) => onUpdate({ padding: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          placeholder="10px"
        />
      </div>

      {block.type === 'row' && (
        <div>
          <label className={`
            block text-sm font-medium mb-1
            ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
          `}>
            Number of Columns
          </label>
          <input
            type="number"
            value={content.columns || 1}
            onChange={(e) => onUpdate({ columns: parseInt(e.target.value) || 1 })}
            className={`
              w-full px-3 py-2 border rounded-md
              ${isDarkMode 
                ? 'bg-gray-700 border-gray-600 text-white' 
                : 'bg-white border-gray-300 text-gray-900'
              }
            `}
            min="1"
            max="4"
          />
        </div>
      )}

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Alignment
        </label>
        <select
          value={content.align || 'left'}
          onChange={(e) => onUpdate({ align: e.target.value as any })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>
    </div>
  );
};
